import { call, options, params } from './helpers';

export const getAllTableViews = ({ tableType, ...payload }) =>
	call(`/beta/table-views${params(payload)}`);

export const getTableView = ({ id, ...payload }) =>
	call(`/beta/table-views/${id}${params(payload)}`);

export const updateTableView = ({ id, ...payload }) =>
	call(`/beta/table-views/${id}`, options(payload, 'PUT'));

export const createTableView = (payload) =>
	call(`/beta/table-views`, options(payload, 'POST'));

export const deleteTableView = ({ id, ...payload }) =>
	call(`/beta/table-views/${id}`, options(null, 'DELETE'));
